import { deepClone } from './object';

const intersect = (a, b) => {
	const inter = [];
	const inA = {};
	let i = 0;

	for (i = 0; i < a.length; i += 1) {
		inA[a[i]] = true;
	}
	for (i = 0; i < b.length; i += 1) {
		if (inA[b[i]]) inter[inter.length] = b[i];
	}
	return inter;
};

const unique = (a) => {
	const na = [];

	// eslint-disable-next-line
	lbl:for (let i = 0; i < a.length; i += 1) {
		for (let j = 0; j < na.length; j += 1) {
			if (na[j] === a[i]) continue lbl; // eslint-disable-line no-continue, no-labels
		}
		na[na.length] = a[i];
	}
	return na;
};

const flatten = (arr) => (
	arr.reduce((flat, toFlatten) => (
		flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten)
	), [])
);

const shuffle = (b, seed) => {
	const a = deepClone(b);
	for (let i = a.length - 1; i > 0; i -= 1) {
		const random = seed && Array.isArray(seed) ? seed[i % seed.length] : Math.random();
		const j = Math.floor(random * (i + 1));
		const x = a[i];
		a[i] = a[j];
		a[j] = x;
	}
	return a;
};

const arraysEqual = (a, b) => {
	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		for (let i = 0; i < a.length; i += 1) {
			if (!arraysEqual(a[i], b[i])) return false;
		}
		return true;
	}
	return a === b;
};

const fillArray = (length, func = () => {}) => [...Array(length)].map(() => func());

export { intersect, unique, flatten, shuffle, arraysEqual, fillArray };
